module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-checked-acb638f8.svg";